import { render } from "./SpinnerComp.vue?vue&type=template&id=682093da&scoped=true"
const script = {}

import "./SpinnerComp.vue?vue&type=style&index=0&id=682093da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/BNRY-technical-assessment/BNRY-technical-assessment/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682093da"]])

export default __exports__